export default __webpack_public_path__ + "static/media/no-authorized.8b1b6f41.svg";